function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M76 38c0 20.987-17.013 38-38 38S0 58.987 0 38 17.013 0 38 0s38 17.013 38 38z",
  fill: "url(#skill_2_svg__paint0_linear)"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21 25l11 11-11 11",
  stroke: "#fff",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M52 47H37",
  stroke: "#fff",
  strokeOpacity: 0.8,
  strokeWidth: 5,
  strokeLinecap: "square",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "skill_2_svg__paint0_linear",
  x1: 38,
  y1: 0,
  x2: 38,
  y2: 76,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#864BD0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BE81CB"
})));

function SvgSkill2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 76 76",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNzYgNzYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJNNzYgMzhDNzYgNTguOTg2OCA1OC45ODY4IDc2IDM4IDc2QzE3LjAxMzIgNzYgMCA1OC45ODY4IDAgMzhDMCAxNy4wMTMyIDE3LjAxMzIgMCAzOCAwQzU4Ljk4NjggMCA3NiAxNy4wMTMyIDc2IDM4WiIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyKSIgLz4KICAgIDxwYXRoIGQ9Ik0yMSAyNUwzMiAzNkwyMSA0NyIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSI1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+CgogICAgPHBhdGggaWQ9ImNvZGUtdW5kZXJsaW5lIiBkPSJNNTIgNDdIMzciIHN0cm9rZT0id2hpdGUiIHN0cm9rZS1vcGFjaXR5PSIwLjgiIHN0cm9rZS13aWR0aD0iNSIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgoKCiAgICA8ZGVmcz4KICAgICAgICA8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXIiIHgxPSIzOCIgeTE9IjAiIHgyPSIzOCIgeTI9Ijc2IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgICAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiM4NjRCRDAiIC8+CiAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI0JFODFDQiIgLz4KICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgPC9kZWZzPgo8L3N2Zz4K";
export { SvgSkill2 as ReactComponent };